import { Label, Text } from "@fluentui/react-components";
import { IAttachment } from "library/types";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Flex } from "components/styled";

type Props = {
  attachment: IAttachment;
};

export function AttachmentItem({ attachment }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <Flex direction="column" align="flex-start">
          <Label weight="semibold">{t("hbh.documentSummary.label")}</Label>
          <Text>{attachment?.attachmentSummary || ""}</Text>
        </Flex>
        <Flex direction="column" align="flex-start">
          <Label weight="semibold">{t("hbh.documentAbstract.label")}</Label>
          <Text>{attachment?.attachmentAbstract || ""}</Text>
        </Flex>
      </Container>
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  gap: 20px;
  padding: 10px;
`;
